import { useAuth } from '../../auth/useAuth';

/**
 * Вычисляет «владельца» уведомлений — идентификатор авторизованного пользователя.
 * `ready` = false, пока профиль ещё грузится (стор трогать нельзя). `owner` = null —
 * анонимный пользователь (сохранённую историю нужно отбросить).
 *
 * ВАЖНО: владелец НЕ зависит от загрузки подписок — иначе медленный/висящий запрос
 * `/subscriptions` заблокировал бы SSE-поток (живые счётчики писем и уведомления). Смена
 * активной подписки инвалидирует данные почты отдельно (useSetActiveSubscription).
 */
export function useNotificationOwner(): { owner: string | null; ready: boolean } {
  const { profile, isLoading } = useAuth();

  if (isLoading || profile === undefined) return { owner: null, ready: false };
  if (!profile.authenticated) return { owner: null, ready: true };

  return { owner: profile.sub ?? profile.email ?? 'user', ready: true };
}
